// extracted by mini-css-extract-plugin
export var animationContainer = "_np-0";
export var footer = "_np-1";
export var gray = "_np-2";
export var lineItem = "_np-3";
export var lineItemImage = "_np-4";
export var lineItemInfo = "_np-5";
export var lineItemText = "_np-6";
export var lineItems = "_np-7";
export var modalContent = "_np-8";
export var options = "_np-9";
export var orderName = "_np-a";
export var refundAmount = "_np-b";